const state = {
    loadingStates: {}
}

const getters = {
    isLoading: state => {
        return Object.values(state.loadingStates).some(state => state)
    },
    isLoadingInitiallyTrue: state => {
        return Object.keys(state.loadingStates).length === 0 ||
            Object.values(state.loadingStates).some(state => state)
    },
    isKeyLoading: state => key => {
        return state.loadingStates[key]
    },
    hasLoadingKey: state => key => {
        return Object.prototype.hasOwnProperty.call(state.loadingStates, key)
    }
}

const mutations = {
    SET_LOADING(state, { key, value }) {
        state.loadingStates = {
            ...state.loadingStates,
            [key]: value
        }
    },
    REMOVE_LOADING_KEY(state, key) {
        const newLoadingStates = { ...state.loadingStates }
        delete newLoadingStates[key]
        state.loadingStates = newLoadingStates
    }
}

const actions = {
    setLoading({ commit }, { key, value }) {
        commit('SET_LOADING', { key, value })
    },
    removeLoadingKey({ commit }, key) {
        commit('REMOVE_LOADING_KEY', key)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
